import {defineMessages} from 'react-intl';

export default defineMessages({
  heading: {
    defaultMessage: 'Logging in...',
    id: 'UserManager.InstantAuthorization.Heading',
  },
});
